import { SuccessfulPurchaseDialog } from '@colonist/clientforge';
import { getNestedTranslation } from '@colonist/i18n';
import { BaseStoreItem } from '../../../../shared/store/BaseStoreItem.ts';
import { StoreItemCategory } from '../../../../shared/entity_datas/StoreEnums.ts';
import { ProfileEditAjaxEndPoints } from '../profile/ProfileEditAjaxEndPoints.ts';
import { notificationController } from '../EntryShared.ts';
import { getLobbyImagePath } from '../ui_utils/Utils.ts';
import { clientI18n } from '../ClientI18n.ts';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderSuccessfulPurchaseDialog = mountDialogUIReactComponent(SuccessfulPurchaseDialog);
export function showSuccessfulPurchaseDialog(item) {
    const itemNameText = clientI18n.t(item.name.key, item.name.options);
    const categoryText = getItemCategoryText(item.category);
    const itemTitle = {
        key: 'strings:storePage.success.youGotItem',
        options: {
            itemName: itemNameText,
            category: categoryText
        }
    };
    renderSuccessfulPurchaseDialog({
        imageUrl: getLobbyImagePath(item.image),
        itemTitle: itemTitle,
        onUseItem: ()=>{
            void activateItem(item);
        }
    });
}
function getItemCategoryText(category) {
    switch(category){
        case StoreItemCategory.Color:
            return clientI18n.t('strings:storePage.sections.color.title', {
                context: 'one'
            });
        case StoreItemCategory.Icon:
            return clientI18n.t('strings:storePage.sections.avatar.title', {
                context: 'one'
            });
        default:
            return '';
    }
}
async function activateItem(item) {
    switch(item.category){
        case StoreItemCategory.Color:
            {
                const playerColor = BaseStoreItem.getPlayerColorOfStorePlayerColor(item.type);
                if (playerColor == undefined) return;
                await ProfileEditAjaxEndPoints.updatePreferredColor(playerColor);
                const colorChangeMessage = getNestedTranslation({
                    key: 'strings:homePage.header.defaultColorSelector.colorChanged'
                }, {
                    color: item.name
                });
                notificationController.showNotification(item.image, colorChangeMessage);
                break;
            }
        case StoreItemCategory.Icon:
            {
                await ProfileEditAjaxEndPoints.updateIcon(item.type);
                const avatarChangeMessage = getNestedTranslation({
                    key: 'strings:homePage.header.avatarSelector.avatarChanged'
                }, {
                    icon: item.name
                });
                notificationController.showNotification(item.image, avatarChangeMessage);
                break;
            }
        default:
            break;
    }
}
